function initPage2(vm, FileTemplateService, self) {
	vm.checkInvestment = true;
	vm.checkTotalInvertment = function() {
		if (vm.proposal.contractType == 'UR2') {
			var totalInvertment = 0;
			for ( var invertment in vm.proposal.investmentList) {
				totalInvertment += Number(vm.proposal.investmentList[invertment].percent);
			}
			if (totalInvertment == 100) {
				vm.checkInvestment = false;
			} else {
				vm.checkInvestment = true;
			}
		} else {
			var totalInvertment = 0;
			for ( var invertment in vm.proposal.investmentList) {
				totalInvertment += Number(vm.proposal.investmentList[invertment].percent);
			}
			if (totalInvertment != 100 && totalInvertment != 0) {
				vm.checkInvestment = true;
			} else if (totalInvertment == 100 || totalInvertment == 0) {
				vm.checkInvestment = false;
			}
		}
	}
	vm.defaultPage2 = function() {
		vm.proposal.investmentList[0].fundCode = "UEQ1";
		vm.proposal.investmentList[1].fundCode = "UGR1";
		vm.proposal.investmentList[2].fundCode = "UBL1";
		vm.proposal.investmentList[3].fundCode = "USB1";
		vm.proposal.investmentList[4].fundCode = "UFI1";
		vm.proposal.investmentList[5].fundCode = "UPS1";
		vm.proposal.investmentList[6].fundCode = "USE1";

		/*
		 * vm.proposal.basic.sumAssured = vm.proposal.basic.sumAssured;
		 * vm.proposal.basic.policyTerm = vm.proposal.basic.policyTerm;
		 * vm.proposal.basic.premiumTerm = vm.proposal.basic.premiumTerm;
		 */
		vm.proposal.basic.componentCode = vm.proposal.contractType;
		if (vm.proposal.contractType == 'TH1' || vm.proposal.contractType == 'TH3') {
			vm.proposal.basic.sumAssured = 400000000;
			vm.proposal.basic.policyTerm = 5;
			vm.proposal.basic.premiumTerm = 5;
		} else if (vm.proposal.contractType == 'TH2') {
			vm.proposal.basic.sumAssured = 100000000;
			vm.proposal.basic.policyTerm = 10;
			vm.proposal.basic.premiumTerm = 10;
		}

		vm.checkTotalInvertment();
	}
	vm.defaultPage2();

	vm.validatePage2 = function() {
		var flag = false;
		flag = vm.validateAllRequired(flag);
		if (vm.checkInvestment) {
			self.addAlert('Tổng danh mục quỹ đầu tư = 100%', 'danger');
			flag = true;
		}
		if(vm.benefitItems !== undefined && vm.benefitItems.length > 1) {
			if (vm.proposal.benefitItem === undefined
					|| vm.proposal.benefitItem === null
					|| vm.proposal.benefitItem === '') {
				self.addAlert('Quyền lợi bảo hiểm chưa được chọn', 'danger');
				flag = true;
			}
		}
		return flag;
	}

	vm.validatePage2Send = function() {
		var flag = false;

		if ((vm.checkInvestment && vm.proposal.contractType == 'UR2')
				|| vm.proposal.basic.sumAssured == null
				|| vm.proposal.basic.policyTerm == null
				|| vm.proposal.basic.premiumTerm == null) {
			self.addAlert('Tab thông tin SP chưa nhập đầy đủ thông tin!');
			flag = true;
		}
		return flag;
	}
}
